import script from "./ConsoleView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsoleView.vue?vue&type=script&lang=ts&setup=true"

import "./ConsoleView.vue?vue&type=style&index=0&id=bee4ea9c&lang=scss"

const __exports__ = script;

export default __exports__